import React from 'react';
import { DriverCopy } from './driverI18n';

interface Props {
  t: DriverCopy;
  docId: string | null;
  onClose: () => void;
}

export const DriverLegalModal: React.FC<Props> = ({ t, docId, onClose }) => {
  const doc = t.legalDocs.find((item) => item.id === docId);
  if (!doc) return null;

  return (
    <div className="driver-offer-backdrop" onClick={onClose}>
      <div
        className="driver-offer-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="driver-legal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="driver-offer-head">
          <h2 id="driver-legal-title">{doc.title}</h2>
          <button type="button" className="driver-offer-close" onClick={onClose} aria-label={t.offerClose}>
            ×
          </button>
        </div>
        <div className="driver-offer-body">
          {doc.sections.map((section) => (
            <section key={section.title}>
              <h3>{section.title}</h3>
              <p>{section.text}</p>
            </section>
          ))}
        </div>
        <button type="button" className="btn-login" onClick={onClose}>
          {t.offerClose}
        </button>
      </div>
    </div>
  );
};

export const DriverLegalLinks: React.FC<{
  t: DriverCopy;
  onOpen: (id: string) => void;
}> = ({ t, onOpen }) => (
  <ul className="driver-legal-links">
    {t.legalDocs.map((doc) => (
      <li key={doc.id}>
        <button type="button" className="driver-offer-link" onClick={() => onOpen(doc.id)}>
          {doc.title}
        </button>
      </li>
    ))}
  </ul>
);
